import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { isLive, timeOf, endOf, fmtDay, dayOf } from "@/lib/time";
import { CategoryPill } from "@/components/common";

export function useNowNext() {
  const site = useSite();
  const acts = site.data.activities.filter((a) => a.status !== "cancelada");
  const live = acts.filter((a) => isLive(a, site.now));
  const next = acts.filter((a) => a.start > site.now).slice(0, 4);
  return { live, next, now: site.now, simulated: site.simulated };
}

export default function NowLive({ dark = true }) {
  const site = useSite();
  const { live, next, now, simulated } = useNowNext();
  const card = dark ? "bg-white/5 border-white/10 hover:bg-white/10" : "bg-white border-black/5 hover:shadow-lg";
  return (
    <div data-testid="now-live">
      <p className={`text-sm mb-6 ${dark ? "text-white/70" : "text-slate-600"}`} data-testid="now-clock">
        Hora de Lisboa: <span className="font-mono-x">{fmtDay(dayOf(now))} · {timeOf(now)}</span>{simulated && " (hora simulada)"}
      </p>
      {live.length ? (
        <ul className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {live.map((a) => (
            <li key={a.id}>
              <Link to={`/atividade/${a.slug}`} className={`block rounded-2xl border p-5 transition-colors ${card}`} data-testid={`now-live-item-${a.slug}`}>
                <span className="inline-flex items-center gap-2 text-xs font-bold text-red-500"><span className="h-2 w-2 rounded-full bg-red-600 live-dot" />AGORA · até {timeOf(endOf(a))}</span>
                <p className="font-display text-xl font-bold mt-2">{a.title}</p>
                <div className="mt-3 flex flex-wrap items-center gap-2 text-sm opacity-80"><CategoryPill cat={site.cats[a.category_id]} />{site.placeOf(a)}</div>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className={`rounded-2xl border p-6 ${dark ? "border-white/15" : "bg-white"}`} data-testid="now-live-empty">De momento não há atividades a decorrer.{next.length ? " Veja o que vem a seguir:" : ""}</p>
      )}
      {next.length > 0 && (
        <div className="mt-8">
          <p className={`eyebrow mb-3 ${dark ? "text-white/60" : "text-slate-500"}`}>A seguir</p>
          <ul className="grid gap-2 sm:grid-cols-2">
            {next.map((a) => (
              <li key={a.id}><Link to={`/atividade/${a.slug}`} className={`flex gap-4 items-baseline rounded-xl border px-4 py-3 ${card}`} data-testid={`now-next-item-${a.slug}`}>
                <span className="font-mono-x text-sm shrink-0">{dayOf(a.start) !== dayOf(now) ? fmtDay(dayOf(a.start), false).replace(/ de \d{4}/, "") + " · " : ""}{timeOf(a.start)}</span><span className="font-semibold">{a.title}</span>
              </Link></li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
